<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar color="transparent primary--text" flat>
          <v-toolbar-title class="font-weight-bold">
            {{ $tc('material_personalizado') | capitalize }}
          </v-toolbar-title>
          <v-spacer/>
          <template>
            <v-btn icon color="primary" :disabled="cargando" @click="cargarMaterial()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
      </v-col>
    </v-row>

    <visualizar-material-personalizado v-if="material" :material="material"/>

    <v-row v-if="material && material.declaracionAmbientalDermis">
      <v-col cols="9" offset="3" class="primary--text font-weight-bold px-0 pt-6 pb-0">
        {{ $t('titulo_declaracion_ambiental') | capitalize }}
      </v-col>
      <v-col cols="9" offset="3" v-for="impacto in impactos" :key="impacto.codigo"
             v-show="material.declaracionAmbientalDermis[impacto.codigo] != null" class="pa-0">
        <v-text-field :value="exponencial(material.declaracionAmbientalDermis[impacto.codigo],2)"
                      :hint="impacto.nombre" type="text" required :suffix="impacto.unidades" readonly
                      persistent-hint/>
      </v-col>
    </v-row>

    <v-row v-if="prestacionales">
      <v-col cols="9" offset="3" class="primary--text font-weight-bold px-0 pt-6 pb-3">
        {{ $t('titulo_declaracion_prestacional') | capitalize }}
      </v-col>
      <v-col cols="9" offset="3" class="px-0 py-1" v-for="prestacional in prestacionales"
             :key="prestacional.indicador.codigo"
             v-show="typeof material.prestaciones[0].prestacionDermis.parametros[prestacional.indicador.codigo] != 'undefined'">
        <span class="grey--text text--darken-2 mr-1">{{ prestacional.indicador.nombre }}:</span>
        {{
          calcularOpcionValorPres(material.prestaciones[0].prestacionDermis.parametros[prestacional.indicador.codigo])
        }}
        ({{
          calcularUnidadesPres(prestacional, material.prestaciones[0].prestacionDermis.parametros[prestacional.indicador.codigo]).unidades
        }})
        {{
          calcularUnidadesPres(prestacional, material.prestaciones[0].prestacionDermis.parametros[prestacional.indicador.codigo]).norma
        }}
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="9" offset="3">
        <evaluar-material-personalizado v-if="material" :material="material"/>
      </v-col>
    </v-row>

    <v-row v-if="material && material.solicitadaPublicacion && esAdmin">
      <v-col cols="12" class="text-right mt-4">
        <v-btn @click="rechazarPublicacion" color="error">{{ $t("rechazar_publicacion") }}</v-btn>
        <v-btn @click="aceptarPublicacion" class="ml-2" color="primary">{{ $t("aceptar_publicacion") }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import VisualizarMaterialPersonalizado from "@/components/VisualizarMaterialPersonalizado";
import {MOSTRAR_DIALOGO_CONFIRMACION, MOSTRAR_SNACKBAR} from "@/store/store-app";
import {mapState} from "vuex";
import EvaluarMaterialPersonalizado from "@/components/EvaluarMaterialPersonalizado";

export default {
  name: 'MaterialDetallesPagina',
  components: {
    VisualizarMaterialPersonalizado,
    EvaluarMaterialPersonalizado
  },
  props: {
    'id': {required: true, type: Number}
  },
  data: () => ({
    cargando: false,
    material: null,
    impactos: null,
    prestacionales: null
  }),
  mounted() {
    this.cargarMaterial();
    this.cargarImpactos();
  },
  methods: {
    cargarMaterial() {
      this.cargando = true;
      let params = {};
      if (this.$route.query["clave-compartir"]) params["clave-compartir"] = this.$route.query["clave-compartir"];

      HttpHelper.get(`material-personalizado/${this.id}/visualizar`, params)
          .then((res) => {
            this.material = res;
            this.cargarPrestacionales();
          })
          .finally(() => {
            this.cargando = false;
          });
    },
    cargarImpactos() {
      this.impactos = [];

      HttpHelper.get("impactos").then(data => {
        this.impactos = data;
      });
    },
    cargarPrestacionales() {
      if (!this.material || !this.material.prestaciones || this.material.prestaciones.length < 1) return;

      HttpHelper.get(`material-personalizado/indicadores-prestacionales/${this.material.prestaciones[0].codigoMaterial}`)
          .then((resp) => {
            this.prestacionales = resp.defecto.concat(resp.resto);
          });
    },
    exponencial(numero, fraccion) {
      return Number.parseFloat(numero).toExponential(fraccion);
    },
    calcularOpcionValorPres(valor) {
      if (!valor) return valor;

      switch (valor.trim().toLowerCase()) {
        case "dnd":
          return "Dato no disponible";
        case "dna":
          return "Dato no aplicable";
        default:
          return valor;
      }
    },
    calcularUnidadesPres(prestacional, valor) {
      if (!valor) return {norma: "", unidades: ""};

      valor = valor.trim();

      let seleccionado = null;
      let esClase = false;
      prestacional.opciones.forEach((opcion) => {
        if (opcion.valor == valor) {
          seleccionado = opcion;
          esClase = true;
        }
      });

      if (!esClase && prestacional.rango) seleccionado = prestacional.rangoDatos;

      return seleccionado;
    },
    aceptarPublicacion() {
      this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
        titulo: this.$t('aceptar_publicacion'),
        color: "primary",
        texto: this.$t('aceptar_pregunta')
      }).then(() => {
        HttpHelper.get(`material-personalizado/${this.id}/aceptar-publicacion`)
            .then(() => {
              this.$store.commit(MOSTRAR_SNACKBAR, {
                texto: this.$t("resp_aceptado"),
                color: "info"
              });
              this.material.solicitadaPublicacion = false;
            });
      });
    },
    rechazarPublicacion() {
      this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
        titulo: this.$t('rechazar_publicacion'),
        color: "error",
        texto: this.$t('rechazar_pregunta')
      }).then(() => {
        HttpHelper.get(`material-personalizado/${this.id}/rechazar-publicacion`)
            .then(() => {
              this.$store.commit(MOSTRAR_SNACKBAR, {
                texto: this.$t("resp_rechazado"),
                color: "info"
              });
              this.material.solicitadaPublicacion = false;
            });
      });
    }
  },
  computed: {
    ...mapState(["usuario"]),
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
    ,
    esAdmin() {
      if (!this.usuario) return false;

      return this.usuario.permisos.includes("ROLE_ADMIN")
    }
  }
}
</script>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "titulo_declaracion_ambiental": "Declaración ambiental",
    "titulo_declaracion_prestacional": "características técnicas",
    "material_personalizado": "Material personalizado",
    "aceptar_publicacion": "Aceptar publicación",
    "rechazar_publicacion": "Rechazar publicación",
    "aceptar_pregunta": "¿Aceptas la publicación de este material?",
    "rechazar_pregunta": "¿Rechazas la publicación de este material?",
    "resp_aceptado": "Publicación del material aceptada",
    "resp_rechazado": "Publicación del material rechazada"
  }
}
</i18n>
<!--@formatter:oon-->
